/**
 * Fingerprint para identificar dispositivo (1 pesquisa por dispositivo).
 * Inclui um deviceId único gerado no localStorage para garantir unicidade por dispositivo.
 * Não usa canvas/WebGL; apenas userAgent, screen, timezone, language e deviceId.
 * Cálculo síncrono, < 5 ms.
 */

const DEVICE_ID_KEY = 'pinkstalker_device_id';

function getOrCreateDeviceId() {
  try {
    let deviceId = localStorage.getItem(DEVICE_ID_KEY);
    if (!deviceId) {
      // Gera um ID único com timestamp + random
      deviceId = `${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 11)}`;
      localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }
    return deviceId;
  } catch (e) {
    // Fallback se localStorage não estiver disponível
    return 'no-storage';
  }
}

export function getFingerprint() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  const language = navigator.language || navigator.userLanguage || '';
  const screenStr = `${window.screen?.width ?? 0}x${window.screen?.height ?? 0}`;
  const ua = navigator.userAgent || '';
  const deviceId = getOrCreateDeviceId();
  // Inclui deviceId para garantir unicidade real por dispositivo
  return `${deviceId}|${ua}|${screenStr}|${timezone}|${language}`;
}

/**
 * Verifica se a flag puxarForce está ativada no localStorage.
 * Quando ativada, ignora a validação de limite de pesquisa.
 * Uso interno apenas - para desenvolvedores/testes.
 */
export function isPuxarForceEnabled() {
  try {
    return localStorage.getItem('puxarForce') === 'true';
  } catch (e) {
    return false;
  }
}
